'use strict';

function doAfter(condition, success, fail, interval, timeout) {
  var settings = {
    condition: typeof condition === 'function' ? condition : null,
    success: typeof success === 'function' ? success : null,
    fail: typeof fail === 'function' ? fail : null,
    interval: typeof interval === 'number' ? interval : 100,
    timeout: typeof timeout === 'number' ? timeout : 10000,
  };
  if (!settings.condition || !settings.success) return false;
  var int = setInterval(function () {
    if (settings.condition()) {
      settings.success();
      clearInterval(int);
      int = null;
    }
  }, settings.interval);
  setTimeout(function () {
    if (int) {
      clearInterval(int);

      if (typeof settings.fail === 'function') {
        settings.fail();
      }
    }
  }, settings.timeout);
  return settings;
}

(function v1() {
  var $;
  doAfter(function () {
    return typeof window.jQuery === 'function';
  }, init);

  function init() {
    $ = window.jQuery;
    var $document = $(document);
    $document.ready(function () {
      $('body').addClass('loaded');
    });
    $document.on('click', '.accordion-content .accordion-content__button', toggleSection);
    $document.on('click', '.tabbed-content__tablinks', toggleTabs);
    $document.on('click', '.tabbed-content__accordion-button', toggleTabection);
  }

  function toggleSection() {
    $(this)
      .toggleClass('accordion-content__button--open')
      .next()
      .slideToggle()
      .toggleClass('accordion-content__panel--open');
  }

  function toggleTabs() {
    var $this = $(this);
    var target = $this.data('target');

    $('.tabbed-content__tabcontent').removeClass('tabbed-content__tabcontent--active');
    $('.tabbed-content__tablinks').removeClass('tabbed-content__tablinks--active');
    $this.addClass('tabbed-content__tablinks--active');
    $('#'.concat(target)).addClass('tabbed-content__tabcontent--active');
  }

  function toggleTabection() {
    $(this)
      .toggleClass('tabbed-content__accordion-button--open')
      .next()
      .slideToggle()
      .toggleClass('tabbed-content__tabcontent-inner--open');
  }
})();

//# sourceMappingURL=global-sections-min.js.map
